import { useContext } from 'react';
import { FormattedMessage } from 'react-intl';

import { RiEyeFill, RiEyeOffFill } from 'react-icons/ri';

import { IconButton, Stack, Typography } from '@mui/material';

import { PortfolioAppreciation, PortfolioPrivacyContext, PrivacyContextAwareMoneyValue } from '../common';

export interface PortfolioBalanceProps {
  allTimeAppreciation: number;
  initialInvestment: number;
  totalBalance: number;
}

export const PortfolioBalance = ({ allTimeAppreciation, initialInvestment, totalBalance }: PortfolioBalanceProps) => {
  const { isPrivacyModeEnabled, togglePrivacyMode } = useContext(PortfolioPrivacyContext);

  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      minHeight="fit-content"
      height="40vh"
      p={6}
      sx={{ backgroundColor: ({ palette }) => palette.darkened.midnight }}
    >
      <Typography
        data-e2e="balance-stat"
        display="flex"
        alignItems="center"
        variant="body1.semibold"
        color={({ palette }) => palette.lightened.bare}
        textTransform="uppercase"
      >
        <FormattedMessage id="balance" defaultMessage="Balance" />
        <IconButton color="inherit" onClick={togglePrivacyMode} sx={{ ml: 0.5 }}>
          {isPrivacyModeEnabled ? <RiEyeFill /> : <RiEyeOffFill />}
        </IconButton>
      </Typography>
      <Typography variant="h2.semibold" color={({ palette }) => palette.lightened.bare}>
        <PrivacyContextAwareMoneyValue value={totalBalance} length={7} />
      </Typography>
      <Typography
        className="appreciation"
        variant="h5.semibold"
        color={({ palette }) => palette.lightened.bare}
        mt={1.5}
      >
        <PortfolioAppreciation appreciation={allTimeAppreciation} initialInvestment={initialInvestment} />
      </Typography>
    </Stack>
  );
};
